// stores/layoutStore.ts
import { defineStore } from 'pinia';

export const useLayoutStore = defineStore('layoutStore', {
    state: () => ({
        isFocused: false,
    }),
    actions: {
        setFocus(state: boolean) {
            this.isFocused = state;
        },
    },
});
